import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"

export const BlendMode = z.union([z.literal("over"), z.literal("add"), z.literal("multiply"), z.literal("darken"), z.literal("lighten"), z.literal("screen")])
export type BlendMode = z.infer<typeof BlendMode>

export const Definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            backgroundImage: anyImageOpResult,
            foregroundImage: anyImageOpResult,
            alpha: anyImageOpResult.or(z.number()).optional(), // for alpha blending, if supplied this will be used instead of alpha channel of foregroundImage
            premultipliedAlpha: z.boolean().optional().default(true),
            blendMode: BlendMode,
        }),
    },
}
